<template>
  <div id="app">
    <router-view />

    <cursor-fx
      ref="cursor"
      :color="color"
      :color-hover="colorHover"
      :outside-size="outsideSizePx"
      :inside-size="insideSizePx"
      :force-custom-slot="forceCustomSlot"
      :config="config"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      color: "#A8C0CE",
      colorHover: "#3c2b92",
      outsideSize: 64,
      insideSize: 6,
      outsideHide: false,
      insideHide: false,
      forceCustomSlot: false,
      config: {
        lerps: {
          dot: 1,
          circle: 0.3,
          custom: 0.18,
        },
        scale: {
          ratio: 0.25,
          min: 0.5,
          max: 1,
        },
        opacity: 1,
      },
    };
  },
  mounted() {
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach((item) => {
      item.addEventListener("click", this.scrollToIdOnClick);
    });
  },
  methods: {
    getScrollTopByHref(element) {
      const id = element.getAttribute("href");
      return document.querySelector(id).offsetTop;
    },
    scrollToPosition(to) {
      // Caso queira o nativo apenas
      window.scroll({
        top: to,
        behavior: "smooth",
      });
    },
    scrollToIdOnClick(event) {
      event.preventDefault();
      const to = this.getScrollTopByHref(event.currentTarget);
      this.scrollToPosition(to);
    },
  },
};
</script>
